import "./collapsedInspector.scss";

import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import Icon from "../../components/interface/Icon";
import { appStateOperations } from "../../modules/appState";
import { mergeDispatchToProps } from "../../utils/codeSplit";

const CollapsedInspectorView = props => {
  return (
    <div className="collapsedInspector" onClick={props.onExpandClick}>
      <div className="collapsePadding" />
      <Icon icon="resizeCollapsed" />
      <div className="collapsePadding" />
    </div>
  );
};

CollapsedInspectorView.propTypes = {
  // Incoming data from parent element
  onExpandClick: PropTypes.func.isRequired
};

const mapStateToProps = (_state, _props) => {
  return {};
};

const readonlyActions = {
  onExpandClick: () => appStateOperations.showRightPanel()
};

const editingActions = {};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CollapsedInspectorView);
